
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.peopleSlider()

        })
        barba.hooks.after((data) => {
            this.peopleSlider()
        });
        
    }
    
    
    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        const blogSlider = new Swiper('.js-blog__slider', {
            loop: true,
            speed:400,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            breakpoints: {
                
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            }
        });
        
        // const blogThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         blogSlider.slideTo(i+1);
        //     })
        // }

        // for(var i = 0; i <  blog_thumbnails.length; i++){
        //     blogThumbnailAddEvent( blog_thumbnails[i],i);
        // }
    }
    peopleSlider(){
        const people = new Swiper('.js-people-slider', {
            loop: true,
            speed:800,
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 70,
            simulateTouch:true,
            centeredSlides: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction:false,
                pauseOnMouseEnter:true
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween:  70,
                    centeredSlides: false,
                }
            }
        })
    }
    
}